import React from "react";
import { Module } from "../../components";

import { HousingHealthInsurance } from "./Pages/HousingHealthInsurance";
import { HousingHealthResults } from "./Pages/HousingHealthResults";

const Saude = () => {
  return (
    <Module moduleName="Caixa Seguradora">
      <Module.Page
        path="/seguro-saude"
        title="Seguro Saúde"
        page={HousingHealthInsurance}
        description="Seguro Sáude"
      />
      <Module.Page
        path="/seguro-saude/resultados"
        title="Programa de Qualificação de Operadoras - PQO"
        page={HousingHealthResults}
        description="Seguro Saúde Empresarial Programa de Qualificação de Operadoras - PQO"
      />
    </Module>
  );
};

Saude.propTypes = {};

export default Saude;
